export default __webpack_public_path__ + "static/media/features-img.7e3a9764.png";